import { Container, CssBaseline, ThemeProvider } from '@mui/material';
import DynamicPage from './DynamicPage';
import theme3 from 'theme/theme3';
import { DynamicForm } from './DynamicForm';
import { useContext, useEffect } from 'react';
import trackAmplitude from 'services/analytics';
import { CW_SEGMENT } from 'utils/AmplitudeTrackEvents';
import { AuthCookieContext } from 'utils/context';
import { useSearchParams } from 'react-router-dom';

export default function DynamicPageWrapper() {
  const [searchParams] = useSearchParams();
  const { userInfo } = useContext(AuthCookieContext);

  useEffect(() => {
    const params = searchParams.size
      ? Object.fromEntries(searchParams.entries())
      : { params: 'not found' };
    trackAmplitude(CW_SEGMENT, {
      funnel_id: userInfo?.templateId,
      ...params,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.templateId]);

  return (
    <ThemeProvider theme={theme3}>
      <CssBaseline />
      <DynamicForm>
        <Container
          maxWidth="xs"
          sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            px: 2,
          }}
        >
          <DynamicPage />
        </Container>
      </DynamicForm>
    </ThemeProvider>
  );
}
